export type Environment = "dev" | "hml" | "sandbox" | "prd";

export const detectEnvironment = (): Environment => {
  if (import.meta.env.DEV) return "dev";

  const hostname = window?.location?.hostname || "";

  if (hostname.startsWith("hml-")) return "hml";
  if (hostname.startsWith("sandbox-")) return "sandbox";

  return "prd";
};
